/**
 * YoutubePlayer view.
 *
 *
 *
 */

var ShapewaysView = require('./ShapewaysView');
var $ = require('./../../sw-jquery/sw-jquery');

var YoutubePlayer = ShapewaysView.extend({

  events: {
    'click [data-sw-youtube-player-play-button]': 'startPlayer'
  },

  initialize: function(options) {
    this.videoId = options.videoId;
  },

  startPlayer: function() {
    var $iframe = $('<iframe />');
    var frameSrc = 'https://www.youtube.com/embed/' + this.videoId + '?autoplay=1&autohide=1&border=0&wmode=transparent';

    $iframe.attr('src', frameSrc);
    $iframe.css({
      'height': this.$el.height(),
      'width': this.$el.width()
    });

    this.$el.replaceWith($iframe);
  }

});

module.exports = YoutubePlayer;
